import { render, staticRenderFns } from "./SupplierCard.vue?vue&type=template&id=a5fb864e&"
import script from "./SupplierCard.vue?vue&type=script&lang=js&"
export * from "./SupplierCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardTitle,
  VDataTable,
  VTextField,
})
